import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ECONNECTIONS } from '../econnections.data';

@Component({
  selector: 'app-e-connection-viewer',
  templateUrl: './e-connection-viewer.component.html',
  styleUrls: ['./e-connection-viewer.component.css']
})
export class EConnectionViewerComponent implements OnInit {
  content: SafeHtml | null = null;
  notFound = false;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const index = Number(params.get('id'));
      const match = ECONNECTIONS[index];

      if (!match) {
        this.notFound = true;
        this.content = null;
        return;
      }

      this.notFound = false;
      this.http.get(match.htmlPath, { responseType: 'text' }).subscribe({
        next: html => this.content = this.sanitizer.bypassSecurityTrustHtml(html),
        error: () => this.notFound = true
      });
    });
  }
}